import React from "react";
import { Dialog, DialogTitle, DialogContent, Button, CircularProgress } from "@mui/material";
import API from "../API";

export default function SecureDocumentViewer() {
  const [request, setRequest] = React.useState(null);
  const [document, setDocument] = React.useState(null);
  const [error, setError] = React.useState("");
  React.useEffect(() => {
    const open = (event) => { setDocument(null); setError(""); setRequest(event.detail); };
    window.addEventListener("panel-document-view", open);
    return () => window.removeEventListener("panel-document-view", open);
  }, []);
  React.useEffect(() => {
    if (!request) return;
    const controller = new AbortController();
    let url;
    API.fetchDocument(request, controller.signal).then((blob) => {
      if (controller.signal.aborted) return;
      url = URL.createObjectURL(blob);
      setDocument({ url, type: blob.type });
    }).catch((err) => { if (!controller.signal.aborted) setError(err.message); });
    return () => { controller.abort(); if (url) URL.revokeObjectURL(url); };
  }, [request]);
  const close = () => { setRequest(null); setDocument(null); setError(""); };
  return <Dialog open={!!request} onClose={close} fullWidth maxWidth="lg">
    <DialogTitle>Belge <Button onClick={close}>Kapat</Button></DialogTitle>
    <DialogContent>{error || (document ? document.type === "application/pdf" ? <iframe title="Belge" src={document.url} style={{ width: "100%", height: "75vh", border: 0 }} /> : <img alt="Seçilen belge" src={document.url} style={{ maxWidth: "100%", maxHeight: "75vh" }} /> : <CircularProgress />)}</DialogContent>
  </Dialog>;
}
